const {KitModule, registerModule} = window;

const BATCH_SIZE = 12;

class LazyList extends KitModule {
  constructor($element) {
    super($element);
    this.$items = [...this.$element.querySelectorAll(':scope > li')];
    this.visibleCount = BATCH_SIZE;

    this.updateVisibility();

    if (this.$sentinel) {
      this.observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) this.loadMore();
        },
        {rootMargin: '200px'},
      );
      this.observer.observe(this.$sentinel);
    }
  }

  loadMore() {
    this.visibleCount += BATCH_SIZE;
    this.updateVisibility();
  }

  updateVisibility() {
    this.$items.forEach(($item, i) => {
      $item.style.display = i < this.visibleCount ? '' : 'none';
    });

    if (this.$sentinel) {
      const allShown = this.visibleCount >= this.$items.length;
      this.$sentinel.style.display = allShown ? 'none' : '';
    }
  }
}

registerModule('LazyList', LazyList);
